export default "__VITE_ASSET__BFmcCLi2__"